export default __webpack_public_path__ + "static/media/score-card-icon.7d86e350.svg";